<template>
  <div class="services">
    <h2>{{ STRINGS.SERVICES }}</h2>
    <ul>
      <li v-for="entry in SERVICES_LIST" :key="entry">
        <span>{{ entry }}</span>
      </li>
    </ul>
    <br>
  </div>
</template>

<script>
import { Vue } from "vue-class-component";
import { STRINGS } from "@/constants";

export default class ServicesComp extends Vue {
  STRINGS = STRINGS;

  SERVICES_LIST = [
    "Diagnostik",
    "Psychopharmaka- Therapie",
    "Beratung",
    "Kranksschreibung",
    "Einleitung von Kuren oder anderen stationären Behandlungen"
  ];
}
</script>

<style>
.services {
  width: 90%;
  max-width: 1000px;
	box-sizing: border-box;
}

.services h2 {
  padding-left: 1rem;
  margin-bottom: 1rem;
  text-align: left;
}

.services ul {
  max-width: 500px;
  padding-left: 1rem;
	list-style-position: inside;
}

.services li {
  text-align: left;
  padding: 0.2rem 0;
  height: 1.5rem;
}

@media (max-width: 500px) {
  .services li {
    height: auto;
    padding: 0.25rem 0;
  }
}
</style>